import React from "react";

const SubCategorySkeleton = () => {
  return (
    <div className="subcategory-section">
      {/* Breadcrumb Skeleton */}
      <div className="breadcrumb">
        <div className="skeleton-text skeleton-breadcrumb"></div>
      </div>

      {/* SubCategory Grid Skeleton */}
      <div className="subcategory-grid no-scrollbar">
        {Array.from({ length: 15 }).map((_, index) => (
          <div key={index} className="subcategory-card skeleton-subcategory-card">
            <div className="subcategory-logo">
              <div className="skeleton-image skeleton-logo-image"></div>
            </div>
            <div className="skeleton-text skeleton-subcategory-name"></div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .skeleton-text {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
          height: 1rem;
        }

        .skeleton-breadcrumb {
          width: 150px;
          height: 1.2rem;
          margin-bottom: 1rem;
        }

        .skeleton-image {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 8px;
        }

        .skeleton-logo-image {
          width: 100%;
          height: 60px;
        }

        .skeleton-subcategory-name {
          width: 80%;
          height: 1rem;
          margin: 0.5rem auto 0;
        }

        .skeleton-subcategory-card {
          background: #fff;
          border: 1px solid #e9ecef;
          border-radius: 8px;
          padding: 1rem;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .skeleton-subcategory-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .subcategory-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
          gap: 1rem;
          padding: 1rem 0;
        }

        .subcategory-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.5rem;
        }

        .subcategory-logo {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .subcategory-grid {
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
          }
        }

        @media (max-width: 576px) {
          .subcategory-grid {
            grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
          }
        }
      `}</style>
    </div>
  );
};

export default SubCategorySkeleton;
